import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default  {
  namespaced: true,
  state: {
      newRequests: [],
      archiveRequests: [],
      activeRequests: []

  },
  actions,
  mutations,
  getters
}
